class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.querySelectorAll('button').forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (!this.input || this.input.disabled) return;

        const previousValue = this.input.value;
        if (button.name === 'plus') {
          this.input.stepUp();
        } else {
          this.input.stepDown();
        }

        if (this.input.value !== previousValue) {
          this.input.dispatchEvent(this.changeEvent);
        }
      });
    });
  }
}

if (!customElements.get('quantity-input')) {
  customElements.define('quantity-input', QuantityInput);
}

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      const button = event.target.closest('a, button');
      if (!button) return;
      event.preventDefault();

      const line = this.dataset.index;
      const cartItems = this.closest('cart-items, cart-drawer-items');
      if (cartItems && line && typeof cartItems.updateQuantity === 'function') {
        cartItems.updateQuantity(line, 0);
        return;
      }

      const href = button.getAttribute('href');
      if (href) window.location.href = href;
    });
  }
}

if (!customElements.get('cart-remove-button')) {
  customElements.define('cart-remove-button', CartRemoveButton);
}

window.debounce = function debounce(fn, wait = window.ON_CHANGE_DEBOUNCE_TIMER || 300) {
  let timeout;
  return function debounced(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => fn.apply(this, args), wait);
  };
};

window.fetchConfig = function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: `application/${type}`,
    },
  };
};
